var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:_vm.classes},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.title)?[_vm._v(" "+_vm._s(_vm.title)+" ")]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }